export enum BUYER_URLS {
  ME = '/buyers/me',
  GET_TOKEN = '/buyers/access-token',
  GET_NONCE = '/buyers/nonce',
  BUYER_IDENTITIES = '/buyerIdentities',
  BUYER_IDENTITIES_STATISTIC = '/buyerIdentities/:id/statistic',
  BUYERS_CSV = '/buyerIdentities/csv',
  BUYER_ACTIVITY = '/buyerIdentities/:id/activities',
}
